(ns hypnos.consumer.panels.home
  "Home/Landing page."
  (:require [hypnos.i18n :refer [tr]]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; fields

(defn- welcome-message
  []
  [:article.message.is-info
   [:div.message-body
    [:p (tr :ui.label/lookup-info)]]])

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;;

(defn panel
  "The patient consult panel"
  []
  [:div.card
   [:div.card-header
    [:p.card-header-title (tr :ui.label/welcome)]]
   [:div.card-content
    [welcome-message]]])
